import { useTranslation } from 'react-i18next'
import { SHORT_CODE_LENGTH } from '../utils/deviceCode'
import CodeInput, { CodeInputProps } from './CodeInput'

export type DeviceCodeInputProps = Omit<CodeInputProps, 'label' | 'length'>

export default function DeviceCodeInput(props: DeviceCodeInputProps) {
  /**
   * The translate function.
   */
  const [t] = useTranslation('common')

  return <CodeInput label={t('enterSixDigitDeviceCode')} length={SHORT_CODE_LENGTH} {...props} />
}
